'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import Icon from '@/components/ui/AppIcon';

const navItems = [
  { href: '/', label: 'Ana Sayfa', icon: 'HomeIcon' },
  { href: '/menu-order', label: 'Menü', icon: 'ShoppingBagIcon' },
  { href: '/rewards-loyalty', label: 'Ödüller', icon: 'StarIcon' },
  { href: '/mobile-payment', label: 'Öde', icon: 'CreditCardIcon' },
  { href: '/personal-profile', label: 'Profil', icon: 'UserCircleIcon' },
] as const;

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-app bottom-nav-blur border-t border-border z-50">
      <div className="flex items-center justify-around px-2 py-2 pb-safe">
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          return (
            <Link
              key={`nav-${item.href}`}
              href={item.href}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-150 min-w-0 ${
                isActive
                  ? 'text-primary' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon
                name={item.icon}
                size={22}
                variant={isActive ? 'solid' : 'outline'}
                className={isActive ? 'text-primary' : 'text-muted-foreground'}
              />
              <span
                className={`text-[10px] font-semibold tracking-wide ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`}
              >
                {item.label}
              </span>
              {isActive && (
                <span className="w-1 h-1 rounded-full bg-primary mt-0.5" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}